import styles from "./checklist.module.css";

export const CategoryOpenIcon = ({
    isOpen,
    className,
}: {
    isOpen?: boolean;
    className?: string;
}) => (
    <svg
        className={`${styles.openIcon} ${isOpen ? styles.openIconOpen : ""} ${className ?? ""}`}
        width="12"
        height="12"
        viewBox="0 0 12 12"
        aria-hidden="true"
    >
        <polygon points="0,0 12,6 0,12" fill="currentColor" />
    </svg>
);
